import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import {
  Input,
  TextArea,
  PhoneNumberInput,
  validators,
  DateInput,
} from '../../../components/Form';
import { useTranslation } from 'react-i18next';


function PersonForm({ newRole }) {
  const { t } = useTranslation();
  return (
    <div>
      {newRole && (
        <Field
          name="role"
          label={t("Roll")}
          component={Input}
          validate={validators.required()}
        />
      )}
      <Field
        name="firstName"
        label={t("Förnamn")}
        component={Input}
        validate={validators.required()}
      />

      <Field
        name="lastName"
        label={t("Efternamn")}
        component={Input}
        validate={validators.required()}
      />

      <Field
        label={t("Email, primär")}
        name="email"
        component={Input}
        validate={validators.email()}
        normalize={email => email.trim()}
      />

      <Field
        label={t("Huvudtelefonnummer")}
        name="phone1"
        component={PhoneNumberInput}
        format={PhoneNumberInput.format}
        normalize={PhoneNumberInput.normalizePhoneNumber}
        validate={validators.phoneNumber()}
      />

      <Field
        label={t("Telefonnummer 2")}
        name="phone2"
        component={PhoneNumberInput}
        format={PhoneNumberInput.format}
        normalize={PhoneNumberInput.normalizePhoneNumber}
        validate={validators.phoneNumber()}
      />

      <Field
        label={t("Telefonnummer 3")}
        name="phone3"
        component={PhoneNumberInput}
        format={PhoneNumberInput.format}
        normalize={PhoneNumberInput.normalizePhoneNumber}
        validate={validators.phoneNumber()}
      />

      <Field
        label={t("Telefonnummer 4")}
        name="phone4"
        component={PhoneNumberInput}
        format={PhoneNumberInput.format}
        normalize={PhoneNumberInput.normalizePhoneNumber}
        validate={validators.phoneNumber()}
      />

      <Field
        label={t("Information")}
        name="information"
        component={TextArea}
      />

      <Field
        label={t("Godkänt datalagring")}
        name="gdprAcceptedAt"
        component={DateInput}
        type="date"
        normalize={DateInput.normalize.date}
        format={DateInput.format.date}
        validate={validators.date()}
      />

    </div>
  );
}

PersonForm.defaultProps = {
  newRole: false,
};

PersonForm.propTypes = {
  newRole: PropTypes.bool,
};

export default PersonForm;
